import { render, staticRenderFns } from "./hls.vue?vue&type=template&id=36fbe745&scoped=true&"
import script from "./hls.vue?vue&type=script&lang=js&"
export * from "./hls.vue?vue&type=script&lang=js&"
import style0 from "./hls.vue?vue&type=style&index=0&id=36fbe745&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbe745",
  null
  
)

export default component.exports